export enum RegionEnum {
  NorthAfrica = 'Africa - North',
  SubSaharanAfrica = 'Africa - Sub-Saharan',
  NorthAmerica = 'Americas - North America',
  SouthAmerica = 'Americas - South America',
  AsiaPacific = 'Asia Pacific',
  Europe = 'Europe',
  MiddleEast = 'Middle East',
  RussiaCaspian = 'Russia & The Caspian',
}
